import { DataKeyType, DefaultDatumDataKey, DefaultDatumLabel, DefaultDatumValue } from './DataProps';

/**
 * A function to get a user-facing label from a datum conforming to the default datum type.
 *
 * @param d The datum from which to extract a label.
 */
export const defaultLabelGetter = <TDatum extends DefaultDatumLabel>(d: TDatum): string => d.label;

/**
 * A function to get a value from a datum conforming to the default datum type.
 *
 * @param d The datum from which to extract a value.
 */
export const defaultValueGetter = <TDatum extends DefaultDatumValue<TValueType>, TValueType>(d: TDatum): TValueType =>
  d.value;

/**
 * A function to get a unique key from a datum conforming to the default datum type.
 *
 * @param d The datum from which to extract a unique key.
 */
export const defaultDataKeyGetter = <
  TDatum extends DefaultDatumDataKey<TDataKeyType>,
  TDataKeyType extends DataKeyType,
>(
  d: TDatum,
): TDataKeyType => d.dataKey;
